import type { ValueOf } from '../../../types/base';

export const SKELETON_VARIANTS = {
  text: 'text',
  icon: 'icon',
  leadVisual: 'lead-visual',
  button: 'button',
  block: 'block',
} as const;
export type SkeletonVariant = ValueOf<typeof SKELETON_VARIANTS>;

export const SKELETON_SHAPES = {
  round: 'round',
  square: 'square',
} as const;
export type SkeletonShape = ValueOf<typeof SKELETON_SHAPES>;

export const SKELETON_TEXT_SIZES = {
  X_SMALL: 'x-small',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  X_LARGE: 'x-large',
  DISPLAY_MEDIUM: 'display-medium',
  DISPLAY_LARGE: 'display-large',
} as const;
export type SkeletonTextSize = ValueOf<typeof SKELETON_TEXT_SIZES>;

export const SKELETON_ICON_SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
} as const;
export type SkeletonIconSize = ValueOf<typeof SKELETON_ICON_SIZES>;

export const SKELETON_LEAD_SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  X_LARGE: 'x-large',
} as const;
export type SkeletonLeadSize = ValueOf<typeof SKELETON_LEAD_SIZES>;

export const SKELETON_BUTTON_SIZES = {
  SMALL: 'small',
  LARGE: 'large',
} as const;
export type SkeletonButtonSize = ValueOf<typeof SKELETON_BUTTON_SIZES>;

export type SkeletonSize =
  | SkeletonTextSize
  | SkeletonIconSize
  | SkeletonLeadSize
  | SkeletonButtonSize;
